// extracted by mini-css-extract-plugin
export default {"cls1":"SignupBanner-cls1_MmZ","cls2":"SignupBanner-cls2__C6 SignupBanner-cls1_MmZ"};